var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100vh","overflow-y":"scroll"}},[_c('appointment-orders',{attrs:{"page":_vm.page}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }